export default __webpack_public_path__ + "static/media/polaBangles2.a5581362.jpg";